import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vnd',
  standalone: true,
})
export class VndPipe implements PipeTransform {
  formatter = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });
  transform(value: string | number, type: 'short' | 'long' = 'long'): string {
    if (type === 'short') {
      const number = +(value || 0);
      if (number < 1000) {
        return this.format(number);
      }
      if (number < 1000000) {
        return `${this.format(number)}`;
      }
      if (number < 1000000000) {
        return `${this.format(number)}`;
      }
      return `${this.format(number / 1000000000)}Tỉ`;
    }
    return this.format(Math.abs(+(value || 0)));
  }

  format(number: number) {
    return this.formatter.format(number).split(/\s/).reverse().join(' ');
  }
}
